import { render, staticRenderFns } from "./FilesMain.vue?vue&type=template&id=3ef5c92e&"
import script from "./FilesMain.vue?vue&type=script&lang=js&"
export * from "./FilesMain.vue?vue&type=script&lang=js&"
import style0 from "./FilesMain.vue?vue&type=style&index=0&id=3ef5c92e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports